import { Fragment, useState } from "react";
import { ChevronsRight } from "react-feather";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn, H3, H6, P } from "../../../../../AbstractElements";
import { ExtraLargeModals, FullScreenModals, WebDesigns } from "../../../../../Constant";
import { FULLSCREEN_DATA } from "../../../../../Data/UiKit/Modal";

const FullScreenModal = () => {
  const [fullScreen, setFullScreen] = useState(false);
  const fullScreenToggle = () => setFullScreen(!fullScreen);
  return (
    <>
      <Btn color="secondary" type="button" onClick={fullScreenToggle}>{FullScreenModals}</Btn>
      <Modal fullscreen fade isOpen={fullScreen} toggle={fullScreenToggle}>
        <ModalHeader toggle={fullScreenToggle}>
          <H3 className="modal-title">{ExtraLargeModals}</H3>
        </ModalHeader>
        <ModalBody className="dark-modal">
        <div className="large-modal-header"><ChevronsRight />
          <H6>{WebDesigns} </H6>
        </div>
        <P className="modal-padding-space">We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.</P>
        {FULLSCREEN_DATA.map(({ title, text }, index) => (
          <Fragment key={index}>
            <div className="large-modal-header">
              <ChevronsRight />
              <H6>{title}</H6>
            </div>
            <P className="modal-padding-space">{text}</P>
          </Fragment>
        ))}
        </ModalBody>
      </Modal>
    </>
  );
};

export default FullScreenModal;
